import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { Paper, Typography, Button } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import UserForm from '../../containers/UserForm/UserForm';
import ReportsTable from '../../containers/ReportsTable/ReportsTable';
import { ROLE_ADMIN } from '../../constants/roles';

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit,
  },
  titleRow: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit * 5,
  },
  manageBtn: {
    color: theme.palette.primary.main,
    backgroundColor: grey[50],
    '&:hover': {
      backgroundColor: grey[200],
    },
  },
});

const propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
  userStore: mobxPropTypes.observableObject.isRequired,
  snackbarStore: mobxPropTypes.observableObject.isRequired,
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

class UserEditPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReady: false,
      user: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { userStore, snackbarStore, match } = this.props;

    userStore.api.users.get({ id: match.params.id })
      .then((response) => {
        this.setState({
          isReady: true,
          user: response,
        });
      })
      .catch(() => {
        snackbarStore.setError({
          title: 'Sorry an error occurred while fetching the user.',
        });
      });
  }

  async handleSubmit(values, setSubmitting) {
    const {
      userStore,
      snackbarStore,
      match,
      history,
    } = this.props;

    try {
      await userStore.api.users.update(match.params.id, values);

      snackbarStore.setSuccess({
        title: 'User has been successfully updated.',
      });

      history.push('/users');
    } catch (error) {
      setSubmitting(false);
      snackbarStore.setError({
        title: `Sorry, an error occurred.${error.errors ? ' Please correct the errors below:' : ''}`,
        duration: null,
        messages: error.errors ? error.errors : null,
      });
    }
  }

  render() {
    const { classes, history } = this.props;
    const { isReady, user } = this.state;

    if (!isReady) {
      return null;
    }

    return (
      <div>
        <Paper className={classes.paper}>
          <UserForm user={user} onSubmit={this.handleSubmit} reset />
        </Paper>

        {user.role !== ROLE_ADMIN && (
          <div>
            <div className={classes.titleRow}>
              <Typography variant="headline">
                Assigned Reports
              </Typography>
              <Button
                className={classes.manageBtn}
                variant="contained"
                color="primary"
                onClick={() => history.push(`/reports/add/${user.id}`)}
              >
                Add New Report
              </Button>
            </div>

            <ReportsTable history={history} userId={user.id} paginate />
          </div>
        )}
      </div>
    );
  }
}

UserEditPage.propTypes = propTypes;
const UserEditPageStyled = withStyles(styles, { withTheme: true })(UserEditPage);
export default inject('userStore', 'snackbarStore')(observer(UserEditPageStyled));



// WEBPACK FOOTER //
// ./src/pages/Users/Edit.js